<div class="container-fluid">
    <div class="card card-outline-primary">
        <div class="card-header card-primary text-sm-center text-white text-center">
            {{translate.currentLang == 'ar'? editResidenceDegree.degreeNameAr: editResidenceDegree.degreeNameEn}}
      </div>
        <div class="panel-body">
            <div class="card-block">
                <form [formGroup]="ResidenceDegreeForm">
                  <div class="container-fluid">

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'ARABICNAME' | translate }}</label>
                          <input type="text" class="form-control form-control-sm" id="DegreeNameAr" formControlName="degreeNameAr">
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'ENGLISHNAME' | translate }}</label>
                          <input type="text" class="form-control form-control-sm" id="DegreeNameEn" formControlName="degreeNameEn">
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'CASHDEGGLCHARTACCOUNTCODE' | translate }}</label>
                          <sanabel-selectize appcode="1003" formControlName="cashDegGlChartAccountCode" [simpleView]="true"></sanabel-selectize>

                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'CREDITDEGREEGLCHARTACCOUNTCODE' | translate }}</label>
                          <!--<input type="text" class="form-control form-control-sm" id="CreditDegreeGlChartAccountCode" formControlName="CreditDegreeGlChartAccountCode">-->
                          <sanabel-selectize appcode="1003" formControlName="creditDegreeGlChartAccountCode" [simpleView]="true"></sanabel-selectize>

                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'COMPDEGREEGLCHARTACCOUNTCODE' | translate }}</label>
                          <!--<input type="text" class="form-control form-control-sm" id="CompDegreeGlChartAccountCode" formControlName="CompDegreeGlChartAccountCode">-->

                          <sanabel-selectize appcode="1003" formControlName="compDegreeGlChartAccountCode" [simpleView]="true"></sanabel-selectize>

                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'CASHMEDGLCHARTACCOUNTCODE' | translate }}</label>
                          <!--<input type="text" class="form-control form-control-sm" id="CashMedGlChartAccountCode" formControlName="CashMedGlChartAccountCode">-->

                          <sanabel-selectize appcode="1003" formControlName="cashMedGlChartAccountCode" [simpleView]="true"></sanabel-selectize>

                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'CREDITMEDGLCHARTACCOUNTCODE' | translate }}</label>
                          <!--<input type="text" class="form-control form-control-sm" id="CreditMedGlChartAccountCode" formControlName="CreditMedGlChartAccountCode">-->
                          <sanabel-selectize appcode="1003" formControlName="creditMedGlChartAccountCode" [simpleView]="true"></sanabel-selectize>

                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'COMPMEDGLCHARTACCOUNTCODE' | translate }}</label>
                          <!-- <input type="text" class="form-control form-control-sm" id="CompMedGlChartAccountCode" formControlName="CompMedGlChartAccountCode">-->
                          <sanabel-selectize appcode="1003" formControlName="compMedGlChartAccountCode" [simpleView]="true"></sanabel-selectize>

                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <!--<label for="nameAr">{{ 'RESTYPE' | translate }}</label>
          <input type="text" class="form-control form-control-sm" id="ResType" formControlName="resType">-->

                          <sanabel-selectize appcode="74" formControlName="resType"></sanabel-selectize>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'LIMITBYHOUR' | translate }}</label>
                          <input type="text" class="form-control form-control-sm" id="LimitByHour" formControlName="limitByHour">
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <!--<label for="nameAr">{{ 'LIMITTYPE' | translate }}</label>
          <input type="text" class="form-control form-control-sm" id="LimitType" formControlName="LimitType">-->
                          <sanabel-selectize appcode="72"
                                             #approxOrAct
                                             formControlName="limitType"></sanabel-selectize>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'LIMITCOST' | translate }}</label>
                          <input type="number" class="form-control form-control-sm" id="LimitCost" formControlName="limitCost">
                        </div>
                      </div>
                    </div>

                    <div class="row">

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'RESBILLITEMCODE' | translate }}</label>
                          <sanabel-selectize appcode="1055" formControlName="resBillItemCode"
                                             #billItem [simpleView]="true"></sanabel-selectize>
                          <!--<input type="text" class="form-control form-control-sm" id="ResBillItemCode" formControlName="resBillItemCode">-->
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'COMPANIONBILLITEMCODE' | translate }}</label>
                          <sanabel-selectize appcode="1055" formControlName="companionBillItemCode"
                                             #billItem [simpleView]="true"></sanabel-selectize>
                          <!--<input type="text" class="form-control form-control-sm" id="CompanionBillItemCode" formControlName="companionBillItemCode">-->
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'FOLLOWUPBILLITEMCODE' | translate }}</label>
                          <!--<input type="text" class="form-control form-control-sm" id="FollowUpBillItemCode" formControlName="followUpBillItemCode">-->
                          <sanabel-selectize appcode="1055" formControlName="followUpBillItemCode"
                                             #billItem [simpleView]="true"></sanabel-selectize>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'STERILIZEBILLITEMCODE' | translate }}</label>
                          <sanabel-selectize appcode="1055" formControlName="sterilizeBillItemCode"
                                             #billItem [simpleView]="true"></sanabel-selectize>
                          <!--<input type="text" class="form-control form-control-sm" id="SterilizeBillItemCode" formControlName="sterilizeBillItemCode">-->
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameAr">{{ 'MEDFOLLOWUPBILLITEMCODE' | translate }}</label>
                          <sanabel-selectize appcode="1055" formControlName="medFollowUpBillItemCode"
                                             #billItem [simpleView]="true"></sanabel-selectize>
                          <!--<input type="text" class="form-control form-control-sm" id="MedFollowUpBillItemCode" formControlName="medFollowUpBillItemCode">-->
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="nameEn">{{ 'BEDCOMPANIONBILLITEMCODE' | translate }}</label>
                          <sanabel-selectize appcode="1055" formControlName="bedCompanionBillItemCode"
                                             #billItem [simpleView]="true"></sanabel-selectize>
                          <!--<input type="text" class="form-control form-control-sm" id="BedCompanionBillItemCode" formControlName="bedCompanionBillItemCode">-->
                        </div>
                      </div>
                    </div>

                    <div class="container-fluid">
                      <div class="row">
                        <div class="col">
                          <btns-ctrl [paramsArr]="controlsParams" (clicked)="onClicked($event)"></btns-ctrl>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
            </div>
        </div>
    </div>
</div>
